export enum PostBlockType{
    TEXT = 'text',
    IMAGE = 'image',
    CODE = 'code',
    YOUTUBE = 'youtube'
}
